import * as React from 'react';
import classNames from 'classnames';
import { useRecoilValue } from 'recoil';

import { useBetaFlag } from '@src/hooks/useBetaFlag';
import { useSurvey } from '@src/hooks/useSurvey';
import { selectSurveyState } from '@src/recoil/selectors/surveyState';

export interface SurveyDebuggerProps {}

/**
 * @name SurveyDebugger
 * @description Used to debug the survey atom... By default we just sort
 * the users answers, but tweak it as needed
 */
export const SurveyDebugger = (_props: SurveyDebuggerProps) => {
  // Hooks
  const { answers, questions } = useSurvey();
  const [open, setOpen] = React.useState(false);
  const isBeta = useBetaFlag();
  const { errors, valid } = useRecoilValue(selectSurveyState);

  // Setup
  const { active, hidden } = questions;
  const count = active.length + hidden.length;
  const keys = Object.keys(answers).sort();
  const sorted: any = {};

  keys.map((key) => {
    sorted[key] = answers[key];
  });

  // 🔌 Short Circuit
  if (!isBeta) return null;

  return (
    <div className="fixed right-4 bottom-4 flex flex-col justify-end">
      <button
        className="mb-2 rounded-lg border border-solid border-stormy bg-white p-2"
        onClick={() => setOpen(!open)}
        type="button"
      >
        {valid ? '🟢' : '🔴'}
      </button>

      <div
        className={classNames(
          'max-h-80 max-w-[200px] overflow-y-auto rounded-lg border border-solid border-stormy bg-white p-2',
          {
            hidden: !open
          }
        )}
      >
        <h3 className="m-0 py-2 font-beatrice-semibold text-base">
          {count} Survey Question
        </h3>
        <details>
          <summary className="w-40 cursor-pointer text-base font-bold">
            Survey Data
          </summary>
          <code>
            <pre>{JSON.stringify(sorted, null, 2)}</pre>
          </code>
        </details>
        <details>
          <summary className="w-40 cursor-pointer text-base font-bold">
            Survey Errors
          </summary>
          <code>
            <pre>{JSON.stringify(errors, null, 2)}</pre>
          </code>
        </details>
      </div>
    </div>
  );
};
